<script setup>
import {useRoute, useRouter} from "vue-router"

import {useUsersStore, useUserGroupsStore} from "@/stores"
import { onMounted } from 'vue'


const route = useRoute()
const router = useRouter()

// /{publicId}/join renders the discount group with that public id (created in
// the admin Groups editor). The store sends a visitor home when no group has
// the id, so old hardcoded join URLs (/select/join, /verified/join, ...) land
// on /home/ until a group with that public id exists.
let thePublicId = route.params.all?.[0]

if (!thePublicId) {
  router.replace('/home/')
}

thePublicId = (thePublicId || '').toLowerCase()

const usersStore = useUsersStore()
let loginDialogVerificationType = null;
({loginDialogVerificationType} = storeToRefs(usersStore))

const userGroupsStore = useUserGroupsStore()
let guestUserGroup;
({ guestUserGroup } = storeToRefs(userGroupsStore))
if (thePublicId) userGroupsStore.getGuestUserGroup(thePublicId,"discount")

onMounted(() => {
  loginDialogVerificationType.value = 'group'
})
</script>

<template>
  <div v-if="guestUserGroup">
    <section class="home-masthead">
      <div class="content-wrapper">
        <div class="masthead-content">
          <HomeMasthead
            :join-page="true"
            :book-btn="false"
            :learn-more-first="true"
            activate-text="Request Access"
            :for-clients="guestUserGroup.joinMessage"
            :ios-app-available="false"
            :show-restaurants-link="false"
          />
        </div>
      </div>
    </section>
    <VDivider thickness="2" />
    <HomeMainContent />
  </div>
</template>

<style lang="scss" scoped>
@use "@core/scss/pages/misc.scss";
.v-text-field .v-field--active input {
  opacity: 1;
}
input[type="text"]
{
  background: rgba(0, 0, 0, 0);
  border: none;
  outline: none;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
